import type { UserId } from '@/schemas/ids';
import { downloadRemoteTeamPresets } from './download';
import { mergeRemoteTeamPresets } from './merge';
import { uploadPendingTeamPresets } from './upload';

export interface SyncResult {
  uploadedCount: number;
  downloadedCount: number;
}

export class TeamPresetsSyncError extends Error {
  constructor(
    message: string,
    public readonly userId: UserId,
    public readonly type: 'upload' | 'download' | 'full',
    public readonly originalError: unknown,
  ) {
    super(message);
    this.name = 'TeamPresetsSyncError';
  }
}

export async function syncTeamPresets(userId: UserId): Promise<SyncResult> {
  try {
    const up = await uploadPendingTeamPresets(userId);
    const down = await downloadRemoteTeamPresets(userId);
    await mergeRemoteTeamPresets(down.presets);
    return { uploadedCount: up.uploaded, downloadedCount: down.presets.length };
  } catch (error) {
    throw new TeamPresetsSyncError(
      error instanceof Error ? error.message : 'Team presets sync failed',
      userId,
      'full',
      error,
    );
  }
}
